module.exports = __webpack_public_path__ + "src/assets/img/payments-bg.799adbc9.png";